// ── Music Player Controller (обычный / реверс / быстрый) ─────────────────────

const COLORS = ["#ff3355", "#00aaff", "#3dffa0", "#ffe600"];
const LABELS = ["A", "B", "C", "D"];

export default function MusicPlayer({ options, selected, result, timeLeft, hint, isReverse, onAnswer }) {
  if (!options.length) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center animate-slide-up">
          <div style={{ fontSize: "3.5rem", marginBottom: "1rem", animation: "float 2s ease-in-out infinite" }}>
            {isReverse ? "🔁" : "🎵"}
          </div>
          <h2 className="font-display text-2xl text-white mb-2">
            {isReverse ? "Слушай наоборот!" : "Слушай!"}
          </h2>
          <p className="font-heading text-[#aaa]">Смотри на главный экран</p>
        </div>
      </div>
    );
  }

  const timerColor = timeLeft > 15 ? "#3dffa0" : timeLeft > 7 ? "#ffe600" : "#ff3355";
  const isAnswered = selected !== null;
  const isCorrect  = result !== null && result.correct === selected;

  return (
    <div className="flex-1 flex flex-col animate-slide-up gap-3">
      {/* Hint + timer */}
      <div className="flex items-center justify-between">
        {hint && (
          <div className="font-heading text-[#aaa] text-sm"
            style={{
              background: "#261d60", border: "2px solid #000",
              borderRadius: ".75rem", boxShadow: "2px 2px 0 #000",
              padding: ".3rem .75rem",
            }}>
            🎵 {hint}
          </div>
        )}
        {!result && (
          <div className="font-display text-xl ml-auto"
            style={{ color: timerColor, textShadow: `0 0 12px ${timerColor}` }}>
            {timeLeft}с
          </div>
        )}
      </div>

      {/* Status banner */}
      {!isAnswered && !result && (
        <div className="text-center animate-pulse-neon">
          <span className="font-display text-lg text-white">Выбери ответ!</span>
        </div>
      )}
      {!isAnswered && !result && isReverse && (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap:"var(--gap-sm)",
          background: "#1a0040", border: "2px solid #9b5de5",
          borderRadius: "0.75rem", padding: "0.4rem 0.85rem",
        }}>
          <span>🔁</span>
          <span className="font-heading text-sm" style={{ color: "#9b5de5" }}>Угадай перевёрнутую мелодию!</span>
        </div>
      )}
      {isAnswered && !result && (
        <div className="text-center">
          <span className="font-heading text-[#9b5de5]">✓ Ответ принят — ждём остальных...</span>
        </div>
      )}
      {result && (
        <div className="text-center animate-bounce-in py-2 rounded-2xl font-display text-xl" style={{
          background: isCorrect ? "#003d20" : "#3d0014",
          border: `2.5px solid ${isCorrect ? "#3dffa0" : "#ff3355"}`,
          boxShadow: "3px 3px 0 #000",
          color: isCorrect ? "#3dffa0" : "#ff3355",
        }}>
          {isCorrect ? "✅ Правильно!" : "❌ Неверно!"}
          {result.song && (
            <div className="font-heading text-sm mt-1" style={{ color: "#ffe600" }}>
              🎵 {result.song} — {result.artist}
            </div>
          )}
        </div>
      )}

      {/* Options 2×2 */}
      <div className="grid grid-cols-2 gap-3 flex-1" style={{ alignContent: "start" }}>
        {options.map((opt, i) => {
          const isThisSelected = selected === i;
          const isThisCorrect  = result && result.correct === i;
          const isThisWrong    = result && selected === i && result.correct !== i;

          let opacity = 1;
          let outline = "none";
          let shadow  = "4px 4px 0 #000";

          if (result) {
            if (isThisCorrect) { outline = "4px solid #fff"; shadow = "6px 6px 0 #000"; }
            else opacity = 0.4;
          } else if (isThisSelected) {
            outline = "4px solid #fff";
          } else if (isAnswered) {
            opacity = 0.5;
          }

          return (
            <button key={i} onClick={() => onAnswer(i)}
              disabled={isAnswered || !!result}
              style={{
                background: COLORS[i], border: "2.5px solid #000",
                borderRadius: "1.25rem", boxShadow: shadow,
                outline, outlineOffset: "2px",
                padding: "1.1rem .5rem", textAlign: "center",
                opacity, transition: "all .2s",
                cursor: isAnswered || result ? "default" : "pointer",
                WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
              }}>
              <div className="font-display" style={{ fontSize:"var(--fs-2xl)", color: "#000", lineHeight: 1 }}>{LABELS[i]}</div>
              <div className="font-heading" style={{ fontSize: ".75rem", color: "#000", lineHeight: 1.3, marginTop: ".25rem" }}>{opt}</div>
              {isThisCorrect && result && <div style={{ fontSize:"var(--fs-lg)", marginTop: ".25rem" }}>✅</div>}
              {isThisWrong   && result && <div style={{ fontSize:"var(--fs-lg)", marginTop: ".25rem" }}>❌</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}